import {
    EnvironmentProviders,
    inject,
    provideAppInitializer,
    Provider,
} from '@angular/core';
import { AuthConfig } from '../../models/auth-config/auth-config.model';
import { AuthService } from '../../services/auth/auth.service';
import { provideAuthConfig } from '../auth-config/auth-config.provider';
import { firstValueFrom } from 'rxjs';

export const provideAuth = (
    config?: Partial<AuthConfig>,
): (Provider | EnvironmentProviders)[] => [
    provideAuthConfig(config),
    provideAppInitializer(() => {
        const authService = inject(AuthService);
        return firstValueFrom(authService.init());
    }),
];
